<template functional>
    <div class="header">
        <nav class="navbar navbar-fixed-top navbar-expand-md navbar-light">
            <div class="navbar-header">
                <RouterLink class="navbar-brand" :to="{path:'/'}">BIMS</RouterLink>
            </div>
            <button
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    class="collapsed navbar-toggler"
                    data-target="#navbarSupportedContent"
                    data-toggle="collapse"
                    type="button"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
        </nav>
        <div class="text-white bg-maroon pl-3 pt-1 pb-1" style="font-size: 14pt">
            Business Information Management System
        </div>
    </div>
</template>

<script>
    export default {};
</script>

<style scoped>
    .header {
        background-color: #ffffff;
    }

    .navbar.navbar-fixed-top {
        padding-bottom: 0;
        padding-left: 0;
        padding-top: 0;
    }

    .navbar-fixed-top .navbar-brand {
        color: #500000;
        font-family: "Bodoni Condensed Cameo", serif;
        font-size: 36pt;
        font-weight: 900;
        letter-spacing: 8px;
        padding-bottom: 0rem;
        padding-left: 0.75rem;
        padding-top: 0rem;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
    }
</style>
